<template>
    <div class="commonFormStyles newMaterialPlan-box">
        <van-nav-bar
            title="订单申请"
            left-text="用料计划"
            left-arrow
            @click-left="swiperright"
        >
        </van-nav-bar>
        <section class="form-con showFontBtn">
            <!-- 弹出日历控件 -->
            <van-popup
                v-model="showCalendar"
                position="bottom"
                :style="{ height: '50%' }"
            >
                <van-datetime-picker
                    v-model="currentDate"
                    type="datetime"
                    @confirm="confirmMonth"
                    @cancel="showCalendar=false"
                ></van-datetime-picker>
            </van-popup>
            <van-collapse v-model="activeNames" :accordion="isAccordion" @change="changePanel">
                <van-form
                    ref="materialPlanForm"
                    :show-error-message="false"
                    scroll-to-error
                    :validate-first="false"
                >
                    <van-collapse-item name="1">
                        <div slot="title">
                            <span class="iconfont icondanjubianhao"></span>
                            <span class="tit-text">基本信息</span>
                        </div>
                        <van-field
                            placeholder="请输入"
                            v-model="formData.order_number"
                            readonly
                        >
                            <div slot="label">
                                订单编号
                            </div>
                        </van-field>
                        <van-field
                            placeholder="请输入"
                            v-model="formData.bill_time"
                            readonly
                        >
                            <div slot="label">
                                登记时间
                            </div>
                        </van-field>
                        <van-field
                            placeholder="请选择"
                            right-icon="arrow"
                            v-model="formData.contract_number"
                            @click="choseContract"
                            readonly
                            clickable
                            :class="formData.contract_number?'haveValue':'noValue'"
                            :rules="[{ required: true, message: '请填写合同编号' }]"
                        >
                            <div slot="label">
                                合同编号<span class="star">*</span>
                            </div>
                        </van-field>
                        <van-field
                            placeholder="请选择合同"
                            v-model="formData.contract_typename"
                            class="init-field"
                            readonly
                            :rules="[{ required: true, message: '请填写合同类型' }]"
                        >
                            <div slot="label">
                                合同类型<span class="star">*</span>
                            </div>
                        </van-field>

                        <van-field
                            placeholder="请选择合同"
                            v-model="formData.sale_method_name"
                            class="init-field"
                            readonly
                            v-if="$store.state.versionMark == 2"
                            :rules="[{ required: true, message: '请填写销售方式' }]"
                        >
                            <div slot="label">
                                销售方式<span class="star">*</span>
                            </div>
                        </van-field>
                        <van-field
                            placeholder="请选择合同"
                            v-model="formData.sale_area_name"
                            class="init-field"
                            readonly
                            v-if="$store.state.versionMark == 2"
                            :rules="[{ required: true, message: '请填写销售区域' }]"
                        >
                            <div slot="label">
                                销售区域<span class="star">*</span>
                            </div>
                        </van-field>

                        <van-field
                            placeholder="请选择合同"
                            v-model="formData.project_name"
                            class="init-field"
                            readonly
                            :rules="[{ required: true, message: '请填写工程名称' }]"
                        >
                            <div slot="label">
                                工程名称<span class="star">*</span>
                            </div>
                        </van-field>
                        <van-field
                            placeholder="请选择合同"
                            v-model="formData.project_type_name"
                            class="init-field"
                            readonly
                            :rules="[{ required: true, message: '请填写工程类型' }]"
                        >
                            <div slot="label">
                                工程类型<span class="star">*</span>
                            </div>
                        </van-field>
                        <van-field
                            placeholder="请选择合同"
                            v-model="formData.project_address"
                            class="init-field"
                            readonly
                            :rules="[{ required: true, message: '请填写工程地址' }]"
                        >
                            <div slot="label">
                                工程地址<span class="star">*</span>
                            </div>
                        </van-field>
                        <van-field
                            placeholder="请选择"
                            right-icon="arrow"
                            v-model="formData.project_address1"
                            @click="routLink('projectAddress')"
                            readonly
                            clickable
                            :class="formData.project_address1?'haveValue':'noValue'"
                            :rules="[{ required: true, message: '请填写当前收货地址' }]"
                        >
                            <div slot="label">
                                当前收货地址<span class="star">*</span>
                            </div>
                        </van-field>
                        <van-field
                            v-if="$store.state.versionMark == 2"
                            :placeholder="formData.construction_method==2?'请选择':''"
                            :right-icon="formData.construction_method==2?'arrow':''"
                            v-model="formData.sgdw_name"
                            @click="choseConstructionEnterprise"
                            readonly
                            clickable
                            :class="formData.sgdw_name?'haveValue':'noValue'"
                            :rules="[{ validator:sgdwValidator, message: '请选择施工单位' }]"
                        >
                            <div slot="label">
                                施工单位<span v-if="formData.is_special_contract == 1" class="star">*</span>
                            </div>
                        </van-field>
                        <van-field
                            v-model="formData.sgdw_code"
                            readonly
                            clickable
                            v-if="$store.state.versionMark == 2"
                            :class="formData.sgdw_code?'haveValue':'noValue'"
                        >
                            <div slot="label">
                                统一社会信用代码
                            </div>
                        </van-field>
                        <van-field
                            placeholder="请选择"
                            right-icon="arrow"
                            v-model="formData.section"
                            @click="showPopup(11)"
                            readonly
                            clickable
                            v-if="$store.state.versionMark == 2"
                            :class="formData.section?'haveValue':'noValue'"
                            :rules="[{ validator:sectionValidator, message: '请选择标段' }]"
                        >
                            <div slot="label">
                                标段<span v-if="formData.is_special_contract == 1" class="star">*</span>
                            </div>
                        </van-field>
                        <van-field
                            placeholder="请选择"
                            right-icon="arrow"
                            v-model="formData.monomer_name"
                            @click="showPopup(9)"
                            readonly
                            clickable
                            :class="formData.monomer_name?'haveValue':'noValue'"
                            v-if="formData.contract_type!=='102-LS2'&&formData.project_type==='103-FJ0'"
                        >
                            <div slot="label">
                                相关单体
                            </div>
                        </van-field>
                        <van-field
                            v-model="formData.cons_floor"
                            :placeholder="consFloorPlaceHolder"
                            type="number"
                            @blur="keyboardBlur"
                            v-if="formData.contract_type!=='102-LS2' && $store.state.versionMark == 2"
                            @input="updateVal($event)"
                            @focus="End($event)"
                            clearable
                        >
                            <div slot="label">
                                施工楼层
                            </div>
                        </van-field>
                        <van-field
                            placeholder="请选择合同"
                            v-model="formData.customer_name"
                            class="init-field"
                            readonly
                            :rules="[{ required: true, message: '请填写客户名称' }]"
                        >
                            <div slot="label">
                                客户名称<span class="star">*</span>
                            </div>
                        </van-field>
                        <van-field
                            placeholder="请选择合同"
                            v-model="formData.customer_xydm"
                            class="init-field"
                            readonly
                        >
                            <div slot="label">
                                统一信用代码(身份证)
                            </div>
                        </van-field>
                        <van-field
                            placeholder="请选择"
                            v-model="formData.gdylr"
                            readonly
                            clickable
                            name="picker"
                            @click="chooseYLR"
                            :class="formData.gdylr?'haveValue':'noValue'"
                            :rules="[{ required: false, message: '请填写要料人' }]"
                        >
                            <div slot="label">
                                要料人
                            </div>
                        </van-field>
                        <van-field
                            v-model="formData.gdylr_phone"
                            type="tel"
                            label="联系电话"
                            placeholder="请输入"
                            :rules="[{ required: true, message: '请填写联系电话' }]"
                        ></van-field>
                        <van-field
                            placeholder="请选择"
                            v-model="formData.station_name"
                            readonly
                            clickable
                            name="picker"
                            @click="showStation = true"
                            :class="formData.station_name?'haveValue':'noValue'"
                            :rules="[{ required: true, message: '请填写生产站点' }]"
                        >
                            <div slot="label">
                                生产站点<span class="star">*</span>
                            </div>
                        </van-field>
                        <van-field
                            placeholder="请输入"
                            v-model="formData.haul_distance"
                        >
                            <div slot="label">
                                运距
                            </div>
                        </van-field>
                    </van-collapse-item>
                    <van-collapse-item name="2">
                        <div slot="title">
                            <span class="iconfont icondanjubianhao"></span>
                            <span class="tit-text">订单信息</span>
                        </div>
                        <van-field
                            placeholder="请选择"
                            v-model="formData.arrival_time"
                            readonly
                            clickable
                            @focus="showCalendar=true"
                            right-icon="arrow"
                            :class="formData.arrival_time?'haveValue':'noValue'"
                            :rules="[{ required: true, message: '请填写到货时间' }]"
                        >
                            <div slot="label">
                                到货时间<span class="star">*</span>
                            </div>
                        </van-field>
                        <van-field
                            placeholder="请输入"
                            v-model="formData.quantity"
                            readonly
                            clickable
                            @click="showKeyboard=true"
                            :rules="[{ required: true, message: '请填写订货方量' }]"
                        >
                            <div slot="label">
                                订货方量<span class="star">*</span>
                            </div>
                        </van-field>
                        <van-field
                            placeholder="请选择"
                            v-model="formData.strength_grade_name"
                            readonly
                            clickable
                            name="picker"
                            @click="showPopup(1)"
                            right-icon="arrow"
                            :class="formData.strength_grade_name?'haveValue':'noValue'"
                            :rules="[{ required: true, message: '请选择强度等级' }]"
                        >
                            <div slot="label">
                                强度等级<span class="star">*</span>
                            </div>
                        </van-field>
                        <van-field
                            placeholder="请选择"
                            v-model="formData.special_require_name"
                            readonly
                            clickable
                            name="picker"
                            @click="showRequireList()"
                            right-icon="arrow"
                            :class="formData.special_require_name?'haveValue':'noValue'"
                        >
                            <div slot="label">
                                附加型号
                            </div>
                        </van-field>
                        <van-field
                            placeholder="请选择"
                            readonly
                            clickable
                            name="picker"
                            :value="formData.transport_name"
                            @click="showPopup(5)"
                            right-icon="arrow"
                            :class="formData.transport_name?'haveValue':'noValue'"
                            :rules="[{ required: true, message: '请选择运输方式' }]"
                        >
                            <div slot="label">
                                运输方式<span class="star">*</span>
                            </div>
                        </van-field>
                        <van-field
                            placeholder="请选择"
                            readonly
                            clickable
                            name="picker"
                            :value="formData.pouring_name"
                            @click="showPopup(6)"
                            right-icon="arrow"
                            :class="formData.pouring_name?'haveValue':'noValue'"
                            :rules="[{ required: true, message: '请选择浇筑方式' }]"
                        >
                            <div slot="label">
                                浇筑方式<span class="star">*</span>
                            </div>
                        </van-field>
                        <van-field
                            placeholder="请选择"
                            readonly
                            clickable
                            name="picker"
                            :value="formData.pump_truck_name"
                            @click="showPopup(7)"
                            right-icon="arrow"
                            :class="formData.pump_truck_name?'haveValue':'noValue'"
                        >
                            <div slot="label">
                                泵车类型
                            </div>
                        </van-field>
                        <van-field
                            placeholder="请输入"
                            v-model="formData.limited_height"
                            @input="updateVal($event)"
                            @focus="End($event)"
                            clearable
                        >
                            <div slot="label">
                                工地限高(米)
                            </div>
                        </van-field>
                        <van-field
                            placeholder="请输入"
                            v-model="formData.limited_volume"
                            @input="updateVal($event)"
                            @focus="End($event)"
                            clearable
                        >
                            <div slot="label">
                                工地限方
                            </div>
                        </van-field>
                        <van-field>
                            <div slot="label">
                                坍落度
                            </div>
                            <div slot="input">
                                <input
                                    type="text"
                                    class="slump slump1"
                                    v-model="formData.slump"
                                    placeholder="请输入"
                                    @focusout="inputFocusout"
                                >
                                ±
                                <input
                                    type="text"
                                    v-model="formData.slump_name"
                                    class="slump"
                                    placeholder="请输入"
                                    @focusout="inputFocusout"
                                >
                            </div>
                        </van-field>
                        <van-field
                            placeholder="请输入"
                            v-model="formData.xclxr"
                            @input="updateVal($event)"
                            @focus="End($event)"
                            clearable
                        >
                            <div slot="label">
                                现场联系人
                            </div>
                        </van-field>
                        <van-field
                            v-model="formData.xclxr_phone"
                            type="tel"
                            label="联系电话"
                            placeholder="请输入"
                            @input="updateVal($event)"
                            @focus="End($event)"
                        ></van-field>
                        <van-cell
                            v-if="isShowPriceDescription"
                            title="价格说明"
                            :value="formData.price_remark"
                            :icon="require('@/assets/images/icons/icon_41.png')"
                        ></van-cell>
                    </van-collapse-item>
                </van-form>
            </van-collapse>
            <div class="option-con">
                <p>工程描述</p>
                <span class="iconfont iconbeizhu"></span>
                <textarea
                    placeholder="请在此输入工程描述"
                    @focus="inputFocus($event)"
                    @focusout="inputFocusout"
                    v-model="formData.project_detail"
                >
                </textarea>
            </div>
            <div class="option-con">
                <p>备注</p>
                <span class="iconfont iconbeizhu"></span>
                <textarea
                    placeholder="请在此输入备注信息"
                    @focus="inputFocus($event)"
                    @focusout="inputFocusout"
                    v-model="formData.remarks"
                >
                </textarea>
            </div>
        </section>
        <footer class="commonFormBtns">
            <van-button type="info" @click="handleSubmit">
                提交
            </van-button>
            <van-button type="default" @click="handleSave(null)">
                保存
            </van-button>
        </footer>
        <!-- 强度等级 -->
        <van-action-sheet
            v-model="showStrengthGrade"
            :actions="strengthGradeColumns"
            @select="strengthGradeConfirm"
            :style="{height: '30%'}"
        ></van-action-sheet>
        <!-- 标段 -->
        <van-action-sheet
            v-model="showSection"
            :actions="sectionColumns"
            @select="sectionConfirm"
            :style="{height: sectionColumns.length>3?'30%':'22%'}"
        ></van-action-sheet>
        <!-- 单体 -->
        <van-action-sheet
            v-model="showMonomer"
            :actions="monomerColumns"
            @select="monomerConfirm"
            :style="{height: monomerColumns.length>3?'30%':'22%'}"
        ></van-action-sheet>
        <!-- 要料人 -->
        <van-action-sheet
            v-model="showGdylr"
            :actions="gdylrColumns"
            @select="gdylrConfirm"
            :style="{height: '30%'}"
        ></van-action-sheet>
        <!-- 供货站点 -->
        <van-action-sheet
            v-model="showStation"
            :actions="stationColumns"
            @select="stationConfirm"
            :style="{height: stationColumns.length>3?'30%':'22%'}"
        ></van-action-sheet>
        <!-- 订货方量 -->
        <van-number-keyboard
            theme="custom"
            extra-key="."
            close-button-text="完成"
            v-model="formData.quantity"
            :show="showKeyboard"
            @blur="showKeyboard = false"
        ></van-number-keyboard>
        <!-- 运输方式 -->
        <van-action-sheet
            v-model="showTransport"
            :actions="transportColumns"
            @select="transportConfirm"
            :style="{height: '20%'}"
        ></van-action-sheet>
        <!-- 泵车类型 -->
        <van-action-sheet
            v-model="showPumpTruck"
            :actions="pumpTruckColumns"
            @select="pumpTruckConfirm"
            :style="{height: '30%'}"
        ></van-action-sheet>
        <!-- 浇筑方式 -->
        <van-action-sheet
            v-model="showPouring"
            :actions="pouringColumns"
            @select="pouringConfirm"
            :style="{height: '30%'}"
        ></van-action-sheet>
        <van-overlay :show="showOverlay">
            <van-loading type="spinner" color="#fff"></van-loading>
        </van-overlay>
    </div>
</template>

<script>
import VueAMap from 'vue-amap';
VueAMap.initAMapApiLoader({
    key: 'b4007ecc143884e79eab2c515ede82cf',
    plugin: ['AMap.GeometryUtil'],
    v: '1.4.4',
});
import { Dialog, Toast } from 'vant';
import util from '@/assets/js/utils';
export default {
    components: {},
    props: {},
    data() {
        return {
            activeNames: '1',
            preActiveNames: '1',
            formData: {}, // 表单数据
            placeCategoryOriginal: [],
            showPlace: false, // 施工部位
            placeColumns: [],
            placeOriginal: [],
            showTransport: false, // 运输方式
            transportColumns: [],
            transportOriginal: [],
            showPouring: false, // 浇筑方式
            pouringColumns: [],
            pouringOriginal: [],
            showPumpTruck: false, // 泵车类型
            pumpTruckColumns: [],
            pumpTruckOriginal: [],
            showStation: false, // 供货站点
            stationColumns: [],
            stationOriginal: [],
            showStrengthGrade: false, // 强度等级
            strengthGradeColumns: [],
            strengthGradeOriginal: [],
            showGdylr: false, // 要料人
            gdylrColumns: [],
            gdylrOriginal: [],
            showMonomer: false, // 单体
            monomerColumns: [],
            monomerOriginal: [],
            showSection: false, // 标段
            sectionColumns: [],
            sectionOriginal: [],
            ordernumbers: '',
            currentDate: new Date(),
            showCalendar: false,
            timer: null,
            showNumKeyboard: false, // 是否显示数字键盘
            consFloorPlaceHolder: '', // 施工楼层
            isAccordion: true, // 是否开启手风琴模式
            keyboardNum: '',
            // 数字键盘
            showKeyboard: false,
            showOverlay: false,
            // 选择合同是否关联经销商合同
            isRelatedContract: false,
            // 是否显示价格说明（业务员并且未提交显示）
            isShowPriceDescription: false,
        };
    },
    watch: {},
    computed: {},
    created() {},
    // eslint-disable-next-line complexity
    mounted() {
        // 获取-工程结构
        this.getPlaceCategory('105', 1);
        // 获取-运输方式
        this.getPlaceCategory('304-YS0', 2);
        // 获取-浇筑方式
        this.getPlaceCategory('302-JZ0', 3);
        // 获取-泵车类型
        this.getPlaceCategory('303-BS0', 4);
        this.getStationList();
        const lnglatXY = this.$route.params.lnglatXY || '';
        const address = this.$route.params.address || '';
        this.formData = this.$route.params.formData || this.formData;

        // 是否显示价格说明（业务员并且未提交显示）
        if (this.formData.status === 0) {
            this.showPriceDescription();
        }

        if (!this.$route.params.formData) {
            // 工地限高/限方-默认为0
            this.formData.limited_height = 0;
            this.formData.limited_volume = 0;
        }

        if (lnglatXY) {
            this.formData.project_longitude1 = lnglatXY[0];
            this.formData.project_latitude1 = lnglatXY[1];
        }
        if (address) {
            this.formData.project_address1 = address;
        }
        if (this.formData.contract_version) {
            this.getStrengthGrade();
        }
        if (!this.formData.poid) {
            this.getAutoCode();
        }
        if (this.formData.quantity) {
            if (typeof this.formData.quantity === 'number') {
                this.formData.quantity = this.formData.quantity + '';
            }
        }
        this.$forceUpdate();
        // 选完合同后回调事件
        if (this.$route.params.type === 'selectedProjectCallBack') {
            this.formData.strength_grade = '';
            this.formData.strength_grade_name = '';
            this.formData.special_require = '';
            this.formData.special_require_name = '';
            this.formData.monomer_name = '';
            this.formData.monomer = '';
            this.formData.cons_floor = 0;
            this.formData.ground_floors = 0;
            this.formData.underground_floors = 0;
            if (this.formData.contract_type === '102-LS2') {
                this.formData.gdylr = this.$route.params.client_contact_name;
                this.formData.gdylr_phone = this.$route.params.client_contact_phone;
            }
        }
        if (this.$route.params.type === 'new') {
            this.formData.bill_time = util.currentTimeFormat('yyyy-MM-dd HH:mm:ss');
        }
        if (this.$route.params.type === 'copyNew') {
            this.formData.bill_time = util.currentTimeFormat('yyyy-MM-dd HH:mm:ss');
            this.formData.arrival_time = '';
        }
        if (this.formData.place_category) {
            this.getPlaceCategory(this.formData.place_category, 5);
        }
        if (this.$route.params.type === 'selectSpecialRequireBack') {
            this.activeNames = this.$route.params.activeNames;
        }
        // 选择相关单体
        if (this.$route.params.type === 'selectConstructionEnterpriseBack') {
            this.formData.monomer = '';
            this.formData.monomer_name = '';
            this.formData.gdylr = '';
        }
        // 施工楼层区间
        if (this.formData.cons_floor || this.formData.cons_floor === 0) {
            this.formData.cons_floor = this.formData.cons_floor + '';
        } else {
            this.formData.cons_floor = 0;
        }
        if (this.formData.underground_floors && this.formData.ground_floors) {
            this.consFloorPlaceHolder = '请输入' + this.formData.underground_floors + '到' + this.formData.ground_floors + '之间的数字';
        }
        if (this.formData.contract_type) {
            // 拉取合同零售信息
            if (this.formData.contract_type === '102-LS2') {
                this.getContractRetail();
                this.getStrengthByDictionary();
            }
            // 要料人
            if (this.formData.contract_type !== '102-LS2') {
                this.getContractWantmaterial();
            }

            // 获取单体列表
            this.initMonomerList();

        }
        if (this.formData.sale_method_code === '2') {
            this.getAffiliatedDealers().then( isAffiliatedDealers => {
                if (isAffiliatedDealers === 'ok') {
                    this.isRelatedContract = true;
                }
            });
        } else {
            this.isRelatedContract = true;
        }
    },
    methods: {
        // 返回上一页
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 选取合同
        choseContract() {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'selectProject',
                params: {
                    formData: this.formData,
                },
            });
        },
        // 选取施工单位
        choseConstructionEnterprise() {
            if (this.formData.project_code) {
                // eslint-disable-next-line eqeqeq
                if (this.formData.construction_method == 2) {
                    this.$router.isBack = 2;
                    this.$router.push({
                        name: 'selectConstructionEnterprise',
                        params: {
                            formData: this.formData,
                        },
                    });
                }
            } else {
                this.$toast('请先选择合同');
            }
        },
        // 选择要料人
        // eslint-disable-next-line consistent-return
        chooseYLR() {
            // eslint-disable-next-line eqeqeq
            if (this.formData.construction_method == 2 ) {
                if (!this.formData.monomer && this.formData.contract_type !== '102-LS2' && this.formData.project_type === '103-FJ0') {
                    this.$toast('请先选择单体');
                    return false;
                }
                if (!this.formData.sgdw_name) {
                    this.$toast('请先选择施工单位');
                    return false;
                }
                this.getContractWantmaterial();
                this.showGdylr = true;

            } else {
                this.showGdylr = true;
            }
        },
        // 路由跳转
        routLink(rout) {
            if (rout === 'projectAddress') {
                if (this.formData.contract_number) {
                    this.$router.isBack = 2;
                    this.$router.push({
                        name: rout,
                        params: {
                            formData: this.formData,
                            gdylrColumns: this.gdylrColumns,
                            from: 'newMaterialPlan',
                            headerTitle: '当前收货地址',
                        },
                    });
                } else {
                    this.$toast('请先选择合同！');
                }
            } else {
                this.$router.isBack = 2;
                this.$router.push({ name: rout, params: { formData: this.formData, gdylrColumns: this.gdylrColumns } });
            }
        },
        // 选择单体
        choseMonomer(rout) {
            if (this.formData.project_code) {
                this.$router.isBack = 2;
                this.$router.push({ name: rout, params: { formData: this.formData } });
            } else {
                this.$toast('请先选择合同');
            }
        },
        // 获取下拉框数据列表
        getPlaceCategory(parentCode, type) {
            this.$axios
                .get('/interfaceApi/baseinfo/dictionary_config/getlist?parent_code=' + parentCode)
                .then(res => {
                    if (res) {
                        if (type === 2) { // 运输方式
                            this.transportOriginal = res;
                            const arr = [];
                            res.map(item => {
                                arr.push({ name: item.name });
                            });
                            this.transportColumns = arr;
                            if (this.transportOriginal.length > 0) {
                                this.formData.transport = this.transportOriginal[1].code;
                                this.formData.transport_name = this.transportOriginal[1].name;// 默认第二个
                            }
                        } else if (type === 3) { // 浇筑方式
                            this.pouringOriginal = res;
                            const arr = [];
                            res.map(item => {
                                arr.push({ name: item.name });
                            });
                            this.pouringColumns = arr;
                        } else if (type === 4) { // 泵车类型
                            this.pumpTruckOriginal = res;
                            const arr = [];
                            res.map(item => {
                                arr.push({ name: item.name });
                            });
                            this.pumpTruckColumns = arr;
                        } else if (type === 5) { // 施工部位
                            this.placeOriginal = res;
                            const arr = [];
                            res.map(item => {
                                arr.push({ name: item.name });
                            });
                            this.placeColumns = arr;
                        }
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 获取供货站点下拉list
        getStationList() {
            let stationIds = this.$takeTokenParameters('StationIds');
            if (stationIds) {
                stationIds = stationIds.split(',');
                const stationNames = this.$takeTokenParameters('StationNames').split(',');
                const stationList = stationIds.map((id, index) => {
                    return {
                        station_id: id,
                        name: stationNames[index],
                    };
                });
                this.stationOriginal.push(...stationList);
                this.stationColumns = this.stationOriginal.map(item => {
                    return { name: item.name };
                });
            }
        },
        // 获取强度等级
        getStrengthGrade() {
            this.$axios
                .get('/interfaceApi/sale/contract_manager/get_strength_grade?contractNumber=' + this.formData.contract_number)
                .then(res => {
                    if (res) {
                        this.strengthGradeOriginal = res;
                        const arr = [];
                        res.map(item => {
                            arr.push({ name: item.specification_mode_name });
                        });
                        this.strengthGradeColumns = arr;
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 选择附加型号
        showRequireList() {
            if (this.formData.strength_grade) {
                this.$router.isBack = 2;
                this.$router.push({
                    name: 'selectMonomer',
                    params: {
                        formData: this.formData,
                        activeNames: this.activeNames,
                    },
                });
            } else {
                this.$toast('请先选择强度等级');
            }
        },
        // 运输方式选择完成
        transportConfirm(data) {
            this.formData.transport_name = data.name;
            const obj = this.transportOriginal.filter(item => item.name === data.name);
            this.formData.transport = obj[0].code;
            this.showTransport = false;
        },
        // 浇筑方式选择完成
        pouringConfirm(data) {
            this.formData.pouring_name = data.name;
            const obj = this.pouringOriginal.filter(item => item.name === data.name);
            this.formData.pouring = obj[0].code;
            this.showPouring = false;
        },
        // 泵车类型选择完成
        pumpTruckConfirm(data) {
            this.formData.pump_truck_name = data.name;
            const obj = this.pumpTruckOriginal.filter(item => item.name === data.name);
            this.formData.pump_truck = obj[0].code;
            this.showPumpTruck = false;
        },
        // 供货站点选择完成
        stationConfirm(data) {
            this.formData.station_name = data.name;
            const obj = this.stationOriginal.filter(item => item.name === data.name);
            this.formData.station = obj[0].station_id;
            this.showStation = false;
        },
        // 强度等级选择完成
        strengthGradeConfirm(data) {
            this.formData.specification_mode_name = data.name;
            const obj = this.strengthGradeOriginal.filter(item => item.specification_mode_name === data.name)[0];

            this.formData.product_mark_code = obj.product_mark_code;
            this.formData.strength_grade = obj.product_mark_code;
            this.formData.strength_grade_name = obj.product_mark_num;
            this.formData.specification_mode_name = obj.specification_mode_name;
            this.formData.info_price_additional_model_code = obj.additional_model_code;
            this.formData.info_price_additional_model = obj.additional_model;
            this.formData.special_require_name = obj.additional_model;
            this.formData.special_require = obj.additional_model_code;
            this.formData.info_price_pouring = obj.pouring;
            this.formData.price = obj.product_mark_price;
            this.formData.price_remark = `${obj.specification_mode_name}：${obj.product_mark_price}（元）`;
            this.showStrengthGrade = false;
        },
        // 要料人选择完成
        gdylrConfirm(data) {
            this.formData.gdylr = data.name;
            const obj = this.gdylrOriginal.filter(item => item.want_material_name === data.name);
            this.formData.gdylr_phone = obj[0].want_material_phone;
            this.showGdylr = false;
        },
        // 单体选择完成
        monomerConfirm(data) {
            this.formData.monomer_name = data.name;
            const obj = this.monomerOriginal.filter(item => item.monomer_name === data.name);
            this.formData.monomer = obj[0].monomer_number;
            if (!obj[0].ground_floors) {
                obj[0].ground_floors = 0;
            }
            if (!obj[0].underground_floors) {
                obj[0].underground_floors = 0;
            }
            this.formData.ground_floors = obj[0].ground_floors;
            this.formData.underground_floors = obj[0].underground_floors;
            if (this.formData.underground_floors && this.formData.ground_floors) {
                this.consFloorPlaceHolder = '请输入' + this.formData.underground_floors + '到' + this.formData.ground_floors + '之间的数字';
            }
            this.showMonomer = false;
        },

        // 标段选择完成
        sectionConfirm(item) {
            // 清空单体
            this.formData.monomer = '';
            this.formData.monomer_name = '';

            this.formData.section = item.name;
            this.formData.section_id = item.id;

            this.initMonomerList();
            this.showSection = false;
        },
        // 验证施工楼层
        asyncValidator() {
            let b = true;
            if (this.formData.ground_floors && this.formData.underground_floors && this.formData.monomer_name) {
                if (Number(this.formData.underground_floors) <= Number(this.formData.cons_floor)
                && Number(this.formData.cons_floor) <= Number(this.formData.ground_floors)) {
                    b = true;
                } else {
                    b = false;
                }
            }
            return b;
        },
        keyboardBlur() {
            const b = this.asyncValidator();
            if (!b) {
                Toast(this.consFloorPlaceHolder);
            }
        },
        // 其他信息-下拉选择
        // eslint-disable-next-line complexity
        showPopup(type) {
            switch (type) {
                case 1: // 强度等级
                    if (this.strengthGradeColumns.length > 0) {
                        this.showStrengthGrade = true;
                    } else {
                        this.showStrengthGrade = false;
                        Toast('当前合同强度等级暂无数据');
                    }
                    break;
                case 2: // 附加型号
                    if (this.specialRequireColumns.length > 0) {
                        this.showSpecialRequire = true;
                    } else {
                        this.showStrengthGrade = false;
                        Toast('请先选择强度等级');
                    }
                    break;
                case 5: // 运输方式
                    if (this.transportColumns.length > 0) {
                        this.showTransport = true;
                    } else {
                        this.showTransport = false;
                        Toast('当前合同运输方式暂无数据');
                    }
                    break;
                case 6: // 浇筑方式
                    if (this.pouringColumns.length > 0) {
                        this.showPouring = true;
                    } else {
                        this.showPouring = false;
                        Toast('当前合同浇筑方式暂无数据');
                    }
                    break;
                case 7: // 泵车类型
                    if (this.pumpTruckColumns.length > 0) {
                        this.showPumpTruck = true;
                    } else {
                        this.showPumpTruck = false;
                        Toast('当前合同泵车类型暂无数据');
                    }
                    break;
                case 9: // 选择单体
                    // eslint-disable-next-line eqeqeq
                    if (this.formData.construction_method == 2) {
                        if (!this.formData.sgdw_name) {
                            Toast('请先选择施工单位');
                            break;
                        }
                    }
                    if (!this.formData.project_code) {
                        if (this.formData.contract_type === '102-LS2') {
                            Toast('零售合同不需要选择单体');
                        } else {
                            Toast('请先选择合同');
                        }
                    } else if (this.monomerColumns.length > 0) {
                        this.showMonomer = true;
                    } else {
                        this.showMonomer = false;
                        if (this.formData.contract_type === '102-LS2') {
                            Toast('零售合同不需要选择单体');
                        } else {
                            Toast('当前合同下单体暂无数据');
                        }
                    }
                    break;
                case 10: // 工地要料人
                    if (this.gdylrColumns.length > 0) {
                        this.showGdylr = true;
                    } else {
                        this.showGdylr = false;
                    }
                    break;
                case 11: // 标段
                    if (!this.formData.project_code) {
                        Toast('请先选择合同');
                    } else {
                        this.getSectionList();
                    }
                    break;
                default:
                    // 默认代码块;
            }
        },
        // 初始化订单编号
        getAutoCode() {
            const currentDate = util.currentTimeFormat('yyyy-MM-dd');
            this.$axios.get('/interfaceApi/baseinfo/dictionary_config/getno_custom?code=P'
            + currentDate.split('-').join(''))
                .then(res => {
                    if (res) {
                        this.formData.order_number = res;
                        // this.formData.auto_index = res.AutoIndex;
                        this.$forceUpdate();
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 返回的时间格式化
        formatDate(date) {
            let month = date.getMonth() + 1;
            if (month < 10) {
                month = '0' + month;
            }
            let day = date.getDate();
            if (day < 10) {
                day = '0' + day;
            }
            let Hours = date.getHours();
            if (Hours < 10) {
                Hours = '0' + Hours;
            }
            let Minutes = date.getMinutes();
            if (Minutes < 10) {
                Minutes = '0' + Minutes;
            }
            let Seconds = date.getSeconds();
            if (Seconds < 10) {
                Seconds = '0' + Seconds;
            }
            return `${date.getFullYear()}-${month}-${day} ${Hours}:${Minutes}:${Seconds}`;
        },
        // 时间选择完成
        confirmMonth(value) {
            this.showCalendar = false;
            this.formData.arrival_time = this.formatDate(value);
        },
        // 通过订单编号获取
        getByNum() {
            this.$axios
                .get('/interfaceApi/production/productorder/number/', this.formData.order_number)
                .then(res => {
                    if (res) {
                        this.formData = res;
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 施工单位校验
        sgdwValidator() {
            // 如果时特殊合同，必填
            if (this.formData.is_special_contract === 1) {
                if (!this.formData.sgdw_name) {
                    return false;
                }
            }
            return true;
        },
        // 标段校验
        sectionValidator() {
            // 如果时特殊合同，必填
            if (this.formData.is_special_contract === 1) {
                if (!this.formData.section) {
                    return false;
                }
            }
            return true;
        },
        // 保存
        async handleSave(callBack) {
            if (!this.formData.contract_typename) {
                this.$toast('请选择合同!');
                return;
            }
            if (this.isRelatedContract === false) {
                this.$toast('请先关联经销商合同!');
                return;
            }
            this.isAccordion = false;
            this.preActiveNames = JSON.parse(JSON.stringify(this.activeNames));
            this.activeNames = ['1', '2'];
            this.$forceUpdate();
            const b = this.asyncValidator();
            if (!b) {
                Toast('施工楼层，' + this.consFloorPlaceHolder);
                this.showOverlay = false;
                return;
            }
            let isInRing = false;
            if (this.formData.fence_point) {
                const arr = this.formData.fence_point.split('|');
                const polygonPath = [];
                arr.map(item => {
                    const lngLat = item.split(',');
                    const obj = [lngLat[0], lngLat[1]];
                    polygonPath.push(obj);
                });
                // eslint-disable-next-line no-undef
                const inRing = AMap.GeometryUtil.isPointInRing([this.formData.project_longitude1, this.formData.project_latitude1], polygonPath);
                isInRing = inRing;
            } else {
                isInRing = true;
            }

            if (!isInRing) {
                this.$toast('当前收货地址不在电子围栏范围内，请重新标注收货地址！');
                this.showOverlay = false;
                return;
            }

            if (!this.formData.project_longitude1 || !this.formData.project_latitude1) {
                this.$toast('当前收货地址经纬度不能为空！');
                this.showOverlay = false;
                return;
            }
            if (!this.formData.project_longitude1 || !this.formData.project_latitude1) {
                this.$toast('工程地址数据异常，请先维护工程地址！');
                this.showOverlay = false;
                return;
            }
            if (this.formData.sale_method_code === 2) {
                const isAffiliatedDealers = await this.getAffiliatedDealers();
                if (isAffiliatedDealers !== 'ok') {
                    return;
                }
            }
            const res = await this.getContractClose();
            if (!res) {
                this.$nextTick(() => {
                    this.$refs.materialPlanForm.validate().then(data => {
                        const formData = JSON.parse(JSON.stringify(this.formData));
                        if (formData.cons_floor) {
                            formData.cons_floor = Number(formData.cons_floor);
                        } else {
                            formData.cons_floor = 0;
                        }
                        this.showOverlay = true;
                        if (this.formData.poid) {
                            this.$axios
                                .post('/interfaceApi/production/productorder/modify', formData)
                                .then(() => {
                                    Toast.success('修改成功');
                                    this.getByOrderNum(this.formData.order_number);
                                    this.isAccordion = true;
                                    this.activeNames = this.preActiveNames;
                                    this.$forceUpdate();
                                    if (callBack) {
                                        callBack();
                                    }
                                    setTimeout(() => {
                                        this.showOverlay = false;
                                    }, 0);
                                }).catch(error => {
                                    this.showOverlay = false;
                                    this.$toast(error.ErrorCode.Message);
                                });
                        } else {
                            this.$axios
                                .post('/interfaceApi/production/productorder/add', formData)
                                .then(res => {
                                    if (res) {
                                        this.ordernumbers = res;
                                        Toast.success('保存成功');
                                        this.getByOrderNum(res);
                                        this.isAccordion = true;
                                        this.activeNames = this.preActiveNames;
                                        this.$forceUpdate();
                                        if (callBack) {
                                            callBack();
                                        }
                                        setTimeout(() => {
                                            this.showOverlay = false;
                                        }, 0);
                                    }
                                }).catch(error => {
                                    this.showOverlay = false;
                                    this.$toast(error.ErrorCode.Message);
                                });
                        }
                    }).catch(err => {
                        this.$toast(err[0].message);
                        this.showOverlay = false;
                    });
                });
            } else {
                this.$toast('该合同已关闭，不能复制新增！');
                this.showOverlay = false;
            }
        },
        // 保存成功后的回调
        saveSuccessCallBack() {
            Dialog.confirm({
                title: '确认提交',
                message: '是否确认提交？',
            }).then(() => {
                this.$axios
                    .put('/interfaceApi/production/productorder/submitandconfirme/' + this.formData.order_number)
                    .then(res => {
                        if (res.ResultCode === 1) {
                            this.$router.isBack = 1;
                            this.$router.go(-1);
                        } else if (res.ResultCode === 2) {
                            Dialog.alert({
                                message: res.Description,
                            }).then(() => {
                                this.$router.isBack = 1;
                                this.$router.go(-1);
                            });
                        } else if (res.ResultCode === 3) {
                            Dialog.alert({
                                message: res.Description,
                            }).then(() => {
                            });
                        }
                        // Toast.success('提交成功');


                    }).catch(error => {
                        if (error.ErrorCode.Code === '99') {
                            Dialog({ message: error.ErrorCode.Message });
                        } else {
                            this.$toast(error.ErrorCode.Message);
                        }

                    });
            }).catch(() => {

            });
        },
        // 确认订单
        confirmOrder(orderNum) {
            this.$axios
                .put('/interfaceApi/production/productorder/confirme/' + orderNum)
                .then(res => {
                    if (res.ResultCode === 1) {
                        this.$toast.success('订单已确认！');
                        this.$router.isBack = 1;
                        this.$router.go(-1);
                    } else if (res.ResultCode === 2) {
                        Dialog.alert({
                            message: res.Description,
                        }).then(() => {
                            this.$router.isBack = 1;
                            this.$router.go(-1);
                        });
                    } else if (res.ResultCode === 3) {
                        Dialog.alert({
                            message: res.Description,
                        }).then(() => {
                        });
                    }

                }).catch(error => {
                    if (error.ErrorCode.Code === '99') {
                        Dialog({ message: error.ErrorCode.Message });
                    } else {
                        this.$toast(error.ErrorCode.Message);
                    }
                });
        },
        // 提交
        handleSubmit() {
            this.handleSave(this.saveSuccessCallBack);
        },
        // 通过订单编号拉取订单信息
        getByOrderNum(num) {
            this.$axios
                .get('/interfaceApi/production/productorder/number/' + num)
                .then(res => {
                    if (res.cons_floor) {
                        res.cons_floor = res.cons_floor + '';
                    } else {
                        res.cons_floor = 0;
                    }
                    if (res.quantity) {
                        res.quantity = res.quantity + '';
                    } else {
                        res.quantity = '';
                    }
                    this.formData = res;
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 拉取合同关联要料人
        getContractWantmaterial() {
            let url = '/interfaceApi/sale/contract_manager/get_contract_client_wantmaterial?cvid=' + this.formData.contract_version;
            // eslint-disable-next-line eqeqeq
            if (this.formData.construction_method == 2 && this.formData.sgdw_id) {
                url += '&construction_id=' + this.formData.sgdw_id;
            }
            this.$axios
                .get(url)
                .then(res => {
                    if (res) {
                        this.formData.WantMaterialList = res;
                        this.gdylrOriginal = res;
                        this.gdylrColumns = [];
                        this.formData.WantMaterialList.map(item => {
                            this.gdylrColumns.push({ name: item.want_material_name });
                        });
                        this.$forceUpdate();
                        if (this.$route.params.type === 'selectedProjectCallBack') {
                            this.formData.gdylr = this.formData.WantMaterialList[0].want_material_name;
                            this.formData.gdylr_phone = this.formData.WantMaterialList[0].want_material_phone;
                        }
                    }
                }).catch(error => {
                    if (error.ErrorCode) {
                        this.$toast(error.ErrorCode.Message);
                    }
                });
        },
        inputFocus() {
            clearTimeout(this.timer);
        },
        inputFocusout() {
            this.timer = setTimeout(() => {
                window.scrollTo(0, 0);
                // 间隔设为10，减少页面失去焦点定时器的突兀感，
            }, 10);
        },
        initMonomerList() {
            // eslint-disable-next-line eqeqeq,no-undefined
            if (this.formData.construction_method == 2 && this.formData.sgdw_id != undefined ) {
                this.getMonomerList();
            } else if (this.formData.is_specify_monomer) {
                this.parseContractMonomer();
            } else if (this.formData.contract_type !== '102-LS2') {
                this.getMonomerList();
            }
        },
        // 拉取工程单体列表
        async getMonomerList() {
            const res = await this.getContractVersionApi();
            if (res) {
                let url = '/interfaceApi/sale/engineering_manager/get_monomer_list/' + res.engineering_id
                    + '?section_id=' + (this.formData.section_id || '');
                // eslint-disable-next-line no-undefined,eqeqeq
                if (this.formData.construction_method == 2 && this.formData.sgdw_id != undefined) {
                    // eslint-disable-next-line no-const-assign
                    url += '&contract_version_id=' + this.formData.contract_version + '&construction_id=' + this.formData.sgdw_id;
                }
                this.$axios
                    .get(url)
                    .then(res => {
                        if (res) {
                            this.monomerOriginal = res;
                            const arr = [];
                            res.map(item => {
                                arr.push({ name: item.monomer_name });
                            });
                            this.monomerColumns = arr;
                        }
                    }).catch(error => {
                        this.$toast(error.ErrorCode.Message);
                    });
            }
        },
        // 拉取标段列表
        getSectionList() {
            const url = '/interfaceApi/sale/contract_manager/bid_section/list?contract_version_id='
                + `${this.formData.contract_version}&construction_id=${this.formData.sgdw_id || ''}&pageindex=1&pageSize=999`;
            this.$axios.get(url).then(data => {
                if (data) {
                    this.sectionOriginal = data.rows;
                    const arr = [];
                    this.sectionOriginal.map(item => {
                        arr.push({ name: item.bid_section_name, id: item.ecbsid });
                    });
                    this.sectionColumns = arr;
                }
                this.showSection = true;
            }).catch(error => {
                this.$toast(error.ErrorCode.Message);
            });
        },
        getContractVersionApi() {
            return this.$axios.$get('/interfaceApi/sale/contract_manager/contract_version/' + this.formData.contract_version, { defEx: true });
        },
        // 处理合同单体
        parseContractMonomer() {
            this.$axios
                .get('/interfaceApi/sale/contract_manager/get_contract_monomers?cvid=' + this.formData.contract_version)
                .then(res => {
                    if (res) {
                        this.monomerOriginal = res;
                        const arr = [];
                        res.map(item => {
                            arr.push({ name: item.monomer_name });
                        });
                        this.monomerColumns = arr;
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 拉取合同零售信息
        getContractRetail() {
            this.$axios
                .get('/interfaceApi/sale/contract_manager/get_contract_retail?cvid=' + this.formData.contract_version)
                .then(res => {
                    if (res) {
                        if (this.$route.params.type === 'selectedProjectCallBack') {
                            this.formData.strength_grade = res.strength_grade;
                            this.formData.strength_grade_name = res.strength_grade_name;
                            this.formData.special_require = res.additional_model;
                            this.formData.special_require_name = res.additional_model_name;
                        }
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 砂浆
        getMortar() {
            return this.$axios.get('/interfaceApi/baseinfo/dictionary_config/getlist?parent_code=005-SJ0');
        },
        // 混凝土
        getConcrete() {
            return this.$axios.get('/interfaceApi/baseinfo/dictionary_config/getlist_recursion?parent_code=004');
        },
        // 强度等级-拉取字典
        async getStrengthByDictionary() {
            this.strengthGradeOriginal = [];
            this.strengthGradeColumns = [];
            const mortar = await this.getMortar();
            const concrete = await this.getConcrete();
            if (concrete) {
                concrete.map(item => {
                    if (item.level === 3) {
                        const json = {
                            product_mark_code: item.code,
                            product_mark_num: item.name,
                        };
                        this.strengthGradeOriginal.push(json);
                        this.strengthGradeColumns.push({ name: item.name });
                    }
                });
            }
            if (mortar) {
                mortar.map(item => {
                    const json = {
                        product_mark_code: item.code,
                        product_mark_num: item.name,
                    };
                    this.strengthGradeOriginal.push(json);
                    this.strengthGradeColumns.push({ name: item.name });
                });
            }
        },
        // 切换面板
        changePanel() {
            this.isAccordion = true;
        },
        // 拉取合同是否已经关闭
        getContractClose() {
            return this.$axios.$post('/interfaceApi/sale/contract_manager/is_contract_close_by_number/'
            + this.formData.contract_number, { defEx: true });
        },
        // 拉取合同是否关联经销商
        getAffiliatedDealers() {
            return this.$axios.$get('/interfaceApi/sale/contract_distributor/is_related_distribution_contract/'
            + this.formData.contract_number, { defEx: true });
        },

        updateVal() {
            this.$forceUpdate();
        },
        End(e) {
            const obj = e.srcElement;
            obj.focus();
            const len = obj.value.length;
            setTimeout(() => {
                obj.selectionStart = obj.selectionEnd = len;
            }, 60);
        },
        // 判断是否显示价格说明
        showPriceDescription() {
            const roleCodes = this.$takeTokenParameters('RoleCodes');
            if (roleCodes.indexOf('J01-03') > -1) {
                this.isShowPriceDescription = true;
            }
        },
    },

    destroyed() {
        clearTimeout(this.timer);
    },
};
</script>
<style lang="stylus">
.newMaterialPlan-box
    overflow-x hidden
    .hader-nav
        position initial
    .form-con
        height 100%
        overflow-y auto
        overflow-x hidden
        .slump
            display inline-block
            width 40%
            border none
    .option-con
        width 100%
        padding 0 14rpx 14rpx
        position relative
        background: #fff;
        margin-top: 5rpx
        p
            font-size 14rpx
            color #626262
            line-height 30rpx
        textarea
            width 100%
            height 130rpx
            background: #F8F8F8
            text-indent 0
            border 1px solid #D7D7D7
            border-radius 4px
            padding 10rpx
        .iconbeizhu
            position absolute
            left 20rpx
            top 20rpx
            display none
    .van-overlay
        text-align center
        z-index: 1000;
        .van-loading
            position absolute
            left 50%
            top 50%
            margin-left -15rpx
            margin-top -15rpx
</style>